import { ORDERED_SEO_FRIENDLY_FACET_FILTERS } from '@libs/algolia';

import { FACETS_KEY, URL_ENCODED } from '@/constants/facetedNavigation';

export const clearRefinementSearch = (
    searchForItems: (value: string) => void,
    setSearchFieldValue: (value: string) => void
) => {
    searchForItems('');
    setSearchFieldValue('');
};

export const generateHref = (pathname: string | undefined, attribure: string, value: string) => {
    const urlKey = ORDERED_SEO_FRIENDLY_FACET_FILTERS[attribure];

    if (pathname && urlKey) {
        const categoryPath = pathname.split(`/${FACETS_KEY}/`).at(0);
        const encodedValue = encodeURIComponent(value.toLowerCase()).replaceAll("'", URL_ENCODED.APOSTROPHE);
        return `/${categoryPath}/${FACETS_KEY}/${urlKey}/${encodedValue}`;
    }

    return undefined;
};
